import {reactive} from "vue"

// an FAQ doesn't always have the same ID in different years.
// The attribute here is the latest id for the faq, and will always match the latest year
// i.e. "faqId2024": { "2024" : "faqId2024" }
// if the faq id doesn't change or is unavailable in a certain year, the latest year will be used instead
export const faqMap = reactive({
	"1": {
		"2026": "1",
		"2025": "1",
		"2024": "1",
		"2023": "1",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"6": {
		"2026": "6",
		"2025": "6",
		"2024": "6",
		"2023": "6",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"144": {
		"2026": "144",
		"2025": "144",
		"2024": "144",
		"2023": "144",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"1585": {
		"2026": "1585",
		"2025": "1585",
		"2024": "1585",
		"2023": "1585",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"1893": {
		"2026": "1893",
		"2025": "1893",
		"2024": "1893",
		"2023": "1893",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"3597": {
		"2026": "3597",
		"2025": "3597",
		"2024": "3597",
		"2023": "3597",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"6076": {
		"2026": "6076",
		"2025": "6076",
		"2024": "6076",
		"2023": "6076",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"6077": {
		"2026": "6077",
		"2025": "6077",
		"2024": "6077",
		"2023": "6077",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"6148": {
		"2026": "6148",
		"2025": "6148",
		"2024": "6148",
		"2023": "6148",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"6255": {
		"2026": "6255",
		"2025": "6255",
		"2024": "",
		"2023": "",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"6662": {
		"2026": "6662",
		"2025": "6662",
		"2024": "6662",
		"2023": "6662",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"6665": {
		"2026": "6665",
		"2025": "6665",
		"2024": "6665",
		"2023": "6665",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"7738": {
		"2026": "7738",
		"2025": "7738",
		"2024": "7738",
		"2023": "7738",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"7739": {
		"2026": "7739",
		"2025": "7739",
		"2024": "7739",
		"2023": "7739",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"7740": {
		"2026": "7740",
		"2025": "7740",
		"2024": "7740",
		"2023": "7740",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"7741": {
		"2026": "7741",
		"2025": "7741",
		"2024": "7741",
		"2023": "7741",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"7742": {
		"2026": "7742",
		"2025": "7742",
		"2024": "7742",
		"2023": "7742",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"7744": {
		"2026": "7744",
		"2025": "7744",
		"2024": "7744",
		"2023": "7744",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"7745": {
		"2026": "7745",
		"2025": "7745",
		"2024": "7745",
		"2023": "7745",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"7763": {
		"2026": "7763",
		"2025": "7763",
		"2024": "7763",
		"2023": "7763",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"7798": {
		"2026": "7798",
		"2025": "7798",
		"2024": "7798",
		"2023": "7798",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"7808": {
		"2026": "7808",
		"2025": "7808",
		"2024": "7808",
		"2023": "7808",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"7812": {
		"2026": "7812",
		"2025": "7812",
		"2024": "7812",
		"2023": "7812",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"7828": {
		"2026": "7828",
		"2025": "7828",
		"2024": "7828",
		"2023": "7828",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"7829": {
		"2026": "7829",
		"2025": "7829",
		"2024": "7829",
		"2023": "7829",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"8487": {
		"2026": "8487",
		"2025": "8487",
		"2024": "8487",
		"2023": "8487",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"8488": {
		"2026": "8488",
		"2025": "8488",
		"2024": "8488",
		"2023": "8488",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"8561": {
		"2026": "8561",
		"2025": "8561",
		"2024": "8561",
		"2023": "8561",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"8699": {
		"2026": "8699",
		"2025": "8699",
		"2024": "8699",
		"2023": "8699",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"11118": {
		"2026": "11118",
		"2025": "11118",
		"2024": "11118",
		"2023": "11118",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"11541": {
		"2026": "11541",
		"2025": "11541",
		"2024": "11541",
		"2023": "11463",
		"2022": "10769",
		"2021": "10166",
		"2020": "9581",
		"2019": "8937",
		"2018": ""
	},
	"11542": {
		"2026": "11542",
		"2025": "11542",
		"2024": "11542",
		"2023": "11464",
		"2022": "10770",
		"2021": "10167",
		"2020": "9582",
		"2019": "8938",
		"2018": ""
	},
	"11543": {
		"2026": "11543",
		"2025": "11543",
		"2024": "11543",
		"2023": "11466",
		"2022": "10772",
		"2021": "10169",
		"2020": "9584",
		"2019": "8940",
		"2018": ""
	},
	"11588": {
		"2026": "11588",
		"2025": "11588",
		"2024": "11588",
		"2023": "11465",
		"2022": "10771",
		"2021": "10168",
		"2020": "9583",
		"2019": "8939",
		"2018": ""
	},
	"12476": {
		"2026": "12476",
		"2025": "12476",
		"2024": "",
		"2023": "",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
	"12714": {
		"2026": "12714",
		"2025": "12610",
		"2024": "",
		"2023": "",
		"2022": "",
		"2021": "",
		"2020": "",
		"2019": "",
		"2018": ""
	},
})